import { render, staticRenderFns } from "./AboutHome.vue?vue&type=template&id=437cb07b&scoped=true&"
import script from "./AboutHome.vue?vue&type=script&lang=js&"
export * from "./AboutHome.vue?vue&type=script&lang=js&"
import style0 from "./AboutHome.vue?vue&type=style&index=0&id=437cb07b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437cb07b",
  null
  
)

export default component.exports